import { Accordion, AccordionSummary, AccordionDetails, Icon } from '@mui/material';
import React from 'react';
import styles from './styles';

export interface IAccordianProps {
    data: Array<{
        summary: string;
        detailsNode: React.ReactNode;
    }>;
}

const AccordionComponent = ({ data }: IAccordianProps) => {
    const [expanded, setExpanded] = React.useState(data[0]?.summary ?? '');
    const handleChange = (panel: string) => (_event: unknown, newExpanded: boolean) => {
        if (newExpanded) {
            setExpanded(panel);
        }
    };
    return (
        <>
            {data.map((item) => {
                return (
                    <Accordion
                        id={`accrdion-${item.summary}`}
                        expanded={expanded === item.summary}
                        onChange={handleChange(item.summary)}
                        key={item.summary}
                        elevation={0}
                    >
                        <AccordionSummary
                            id={`accrdion-summary-${item.summary}`}
                            expandIcon={
                                <Icon sx={styles.summaryIcon}>
                                    <img id={`img-clp-${item.summary}`} src="/images/expand-more.svg" alt="" />
                                </Icon>
                            }
                            sx={[styles.accordionSummary, expanded === item.summary ? styles.bold : styles.normal]}
                        >
                            {item.summary}
                        </AccordionSummary>
                        <AccordionDetails id={`accrdion-details-${item.summary}`} sx={styles.accordianDetails}>
                            {item.detailsNode}
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </>
    );
};
export default AccordionComponent;
